import {applySnapshot, types} from "mobx-state-tree"
import loadable from "./mixins/loadable";
import getRequest from "./helpers/getRequest";
import {sDateType} from "./helpers/spectypes";
import {apply} from "ramda";

const rootFilterItem = types.model("rootFilterItem", {
    dimension: "",
    operator: "equals",
    value: ""
})


export const rootFilterModel = types.model("rootFilter",
    {items: types.array(rootFilterItem)}).actions((self) => ({
        setFilter(newNode){
            if (self.items.filter(d => d.dimension == newNode.dimension).length > 0)
            {
                if ((self.items.filter(d => d.dimension == newNode.dimension).length > 1))
                {
                    // случай, когда явно что-то пошло не так.
                    applySnapshot(self.items, self.items.filter(d => d.dimension != newNode.dimension))
                }
                else {
                    const currFilter = self.items.filter(d => d.dimension == newNode.dimension)[0]
                    if (currFilter && currFilter.value == newNode.value) {
                        applySnapshot(self.items, self.items.filter(d => d.dimension != newNode.dimension))
                    } else {
                        currFilter.value = '' + newNode.value
                    }
                }


            } else {
                self.items.push({dimension: newNode.dimension, value: '' + newNode.value })
            }
    }})).views(self => ({
    appendFilter(filter, dimensions){
        const result = (filter || []).slice()
        const zdimensions = dimensions || []
        for (const item of self.items) {
            if ((zdimensions.filter(d => d == item.dimension).length > 0) ||
                (result.filter(d => d.dimension == item.dimension).length > 0))
            {
                // фильтр уже установлен
            }
            else {
                result.push({
                    "dimension": item.dimension,
                    "operator": item.operator,
                    "values": [item.value]
                })
            }
        }
        return result
    }
}))